module.exports = __webpack_public_path__ + "img/place-technology.280b100e.png";